<template>
  <!--   <div class="w-72 min-h-screen bg-beige-academy-500 transform ease-in
    duration-500 mb-20 transition border-t-2 border-beige-academy-400">
    <div class="text-black text-xl">
    </div>
  </div> -->
  <div
    class="fixed inset-0 overflow-hidden"
    aria-labelledby="slide-over-title"
    role="dialog"
    aria-modal="true"
  >
    <on-click-outside :handler="closeMenu">
    <div class="absolute inset-0 overflow-hidden">
      <div class="absolute inset-0" aria-hidden="true"></div>

      <div
        class="
          pointer-events-none
          fixed
          inset-y-0
          right-0
          flex
          max-w-full
          pl-10
          sm:pl-16
        "
      >
        <div class="pointer-events-auto w-screen max-w-md">
          <div
            class="flex h-full flex-col overflow-y-scroll bg-white shadow-xl pt-8"
          >
            <h1 class="uppercase pl-6 text-gray-500 pb-3 font-semibold">
              {{$t('notifications.title')}}
            </h1>
            <ul
              role="list"
              class="flex-1 divide-y divide-gray-200 overflow-y-auto"
            >
              <li>
                <notifications-header></notifications-header>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
      </on-click-outside>
  </div>
</template>

<script>
import OnClickOutside from '@/directives/OnClickOutside';
import NotificationsHeader from '../NotificationsHeader.vue';

export default {
  data() {
    return {
      isPanelVisible: false,
    };
  },

  components: {
    NotificationsHeader,
    OnClickOutside,
  },

  methods: {
    closeMenu() {
      this.$emit('input', false);
    },
  },
};
</script>
